import { render, staticRenderFns } from "./stock-info.vue?vue&type=template&id=961d8576&scoped=true"
import script from "./stock-info.vue?vue&type=script&lang=js"
export * from "./stock-info.vue?vue&type=script&lang=js"
import style0 from "./stock-info.vue?vue&type=style&index=0&id=961d8576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961d8576",
  null
  
)

export default component.exports